// extracted by mini-css-extract-plugin
export default {"metricTemplate":"styles_metricTemplate__q1pQ1","metricTemplate__value":"styles_metricTemplate__value__F-Qt1","metricTemplate__bottom":"styles_metricTemplate__bottom__HyXnl"};